import { req, Request } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper';

const resource = '/gallery/file';

export default {
    getFileById: async (id, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`${resource}/${id}`, token);
        });
        return data;
    },
    deleteFileById: (id, token) => {
        return req(token).then((token) => {
            return Request.delete(`${resource}/${id}`, token);
        });
    },
    getFileContentById: (id, isIos, token, returnType = 2) => {
        return req(token).then((token) => {
            if (isIos) {
                return Request.get(`gallery/getfilecontent?id=${id}&returnImageAsType=${returnType}&isIos=true`, token);
            } else {
                return Request.get(`gallery/getfilecontent?id=${id}&returnImageAsType=${returnType}`, token);
            }
        });
    },
    getXdentThumbnailById: async (id, token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`xdent/file/getThumbnailById?idFile=${id}&imageType=Base64`, token);
        });
        return data;
    },
    setProfilePhoto: (photo, token) => {
        return req(token).then((token) => {
            return Request.post(`profilephoto/addprofilephoto`, photo, {
                ...token,
                accept: 'application/json',
                'Content-Type': `multipart/form-data; boundary=${photo._boundary}`,
            });
        });
    },
};
